'use strict';

/**
 * Returns true if `as` is an array.
 *
 * @private
 */
function isArray(as) {
  return Array.isArray(as);
}

exports.isArray = isArray;
